import React from 'react';
import logo from './logo.svg';
import './App.css';
import RouterPrincipal from './routers/routerMain.js';


function App() {
  return (
    <div className="App">
    <RouterPrincipal/>
    </div>
  );
}

export default App;
